"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PostpaidAccessoryModalState = /** @class */ (function () {
    function PostpaidAccessoryModalState() {
        this.showPopUp = false;
    }
    return PostpaidAccessoryModalState;
}());
exports.default = PostpaidAccessoryModalState;
//# sourceMappingURL=PostpaidAccessoryModalState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/PostpaidAccessoryModal/PostpaidAccessoryModalState.js
// module id = 2292
// module chunks = 8